module.exports = __webpack_public_path__ + "static/media/111.2749e99d.PNG";